'use client';

import React, {useEffect, useRef, useState} from 'react';
import VerticalSingleSelection from '../components/vertical_single_selection';
import TypeInput from '../components/type_input';
import Typography from '@mui/material/Typography';
import { SelectionData } from '../questions';
import { Divider } from '@mui/material';
import ClientComponent from '@/components/builder/client_component';

function DividerWithText({ text }: any) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px', marginBottom: '20px' }}>
        <Divider style={{ flexGrow: 1 }} />
        <Typography variant="body2" className='divider-text'>
          {text}
        </Typography>
        <Divider style={{ flexGrow: 1 }} />
      </div>
    );
  }

const HorizontalBudgetSingleSelection: React.FC<SelectionData> = ({selectedAnswer, setSelectedAnswer, choices, editData, props}) => {
    const [inputValue, setInputValue] = useState<any>((selectedAnswer && selectedAnswer[0]?.answer) ? selectedAnswer[0]?.answer : "");
    const timer = useRef<any>();


    const previousChoiceId = useRef<any>();

    if(editData && editData.responses && editData.responses.length > 0 && 
      editData.responses[0].answers && editData.responses[0].answers.length > 0){
        const answer = editData.responses[0].answers[0] as any;
        previousChoiceId.current = answer;
    }

    useEffect(()=>{
      if(previousChoiceId.current && previousChoiceId.current.choiceid=="4"){
        setInputValue(previousChoiceId.current.answer)
      }
    },[previousChoiceId.current])

    useEffect(()=>{
      if(inputValue.length > 0) {
        clearTimeout(timer.current);
        timer.current = setTimeout(()=>{
          const value = inputValue.trim().replace(/\<\>\:/g, '')          
            setSelectedAnswer([{
              choiceid: "4",
              answer: value,
              choice: value
            }])          
        },500);
      }
    },[inputValue])
    return (<>
            <VerticalSingleSelection 
            selectedAnswer = {selectedAnswer}  
            setSelectedAnswer={setSelectedAnswer} 
            choices={choices} 
            editData={editData}
            props={{"isBudgetFlow": props.isBudgetFlow }} />           
         </>)
  }

  export default ClientComponent(HorizontalBudgetSingleSelection);
  